import { primeCsrf, request } from './client'
import type { Session } from './types'

/** Sign in. The second factor may be supplied here or in a second step. */
export async function login(input: {
  username: string
  password: string
  code?: string
}): Promise<Session> {
  // The CSRF cookie has to exist before the first write of a session, and signing in
  // is that write.
  await primeCsrf()
  return request<Session>('/auth/login/', { method: 'POST', body: input })
}

export function verifyCode(code: string): Promise<Session> {
  return request<Session>('/auth/mfa/verify/', { method: 'POST', body: { code } })
}

export function beginEnrolment(): Promise<{ secret: string; otpauth_uri: string }> {
  return request('/auth/mfa/enrol/', { method: 'POST', body: {} })
}

export function confirmEnrolment(code: string): Promise<Session> {
  return request<Session>('/auth/mfa/confirm/', { method: 'POST', body: { code } })
}

export function logout(): Promise<void> {
  return request('/auth/logout/', { method: 'POST', body: {} })
}
